import { render, staticRenderFns } from "./policyPopup.vue?vue&type=template&id=6835a766&scoped=true&"
import script from "./policyPopup.vue?vue&type=script&lang=js&"
export * from "./policyPopup.vue?vue&type=script&lang=js&"
import style0 from "./policyPopup.vue?vue&type=style&index=0&id=6835a766&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../layers/paketo-buildpacks_npm-install/build-modules/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6835a766",
  null
  
)

export default component.exports